import { ShieldCheck, Star } from "@phosphor-icons/react";
import { PageHero, PageBlock, RelatedLinks, PageCta } from "@/components/PageLayout";

export default function AeronautiqueDefense({ t }) {
  const p = t.pages.aeronautiqueDefense;
  const c = t.pages.common;
  return (
    <>
      <PageHero overline={p.overline} title={p.h1} intro={p.intro} back={c.back} />

      <PageBlock title={p.contextTitle} testid="ad-context">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <p className="lg:col-span-5 text-base md:text-lg leading-relaxed text-[#5A6B7C]">{p.contextText}</p>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {p.constraints.map((k) => (
              <div key={k.name} className="bg-white p-8">
                <h3 className="font-heading text-sm font-bold tracking-[0.15em] uppercase text-[#0B1B3D] mb-3">{k.name}</h3>
                <p className="text-sm text-[#5A6B7C] leading-relaxed">{k.text}</p>
              </div>
            ))}
          </div>
        </div>
      </PageBlock>

      <PageBlock title={p.domainsTitle} gray testid="ad-domains">
        <div className="bg-white px-8 lg:px-12">
          {p.domains.map((d, i) => (
            <div key={d.name} className="grid lg:grid-cols-12 gap-3 lg:gap-10 py-7 border-b border-[#E2E8F0] last:border-0">
              <div className="lg:col-span-5 flex items-baseline gap-4">
                <span className="font-heading text-xs font-bold tracking-widest text-[#9AA5B1]">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-heading text-base font-bold tracking-tight text-[#0B1B3D]">{d.name}</h3>
              </div>
              <p className="lg:col-span-7 text-sm leading-relaxed text-[#5A6B7C]">{d.text}</p>
            </div>
          ))}
        </div>
      </PageBlock>

      <PageBlock title={p.missionsTitle} testid="ad-missions">
        <ul className="grid md:grid-cols-2 gap-x-12 gap-y-4 max-w-5xl">
          {p.missions.map((m) => (
            <li key={m} className="flex items-start gap-3 text-base text-[#2A2D34] leading-snug">
              <span className="text-[#9AA5B1] select-none leading-none mt-1">—</span>
              {m}
            </li>
          ))}
        </ul>
        <p className="mt-12 flex items-center gap-2 text-sm font-medium text-[#0B1B3D]">
          <Star size={16} weight="light" />
          {t.secteurs.items[0].note}
        </p>
      </PageBlock>

      <section className="py-20 lg:py-24 bg-[#0B1B3D] text-white" data-testid="ad-confidentiality">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6 flex gap-5">
            <ShieldCheck size={30} weight="light" className="text-[#8FA1B5] shrink-0" />
            <div>
              <h2 className="font-heading text-2xl font-semibold tracking-tight mb-4">{p.confidentialityTitle}</h2>
              <p className="text-base leading-relaxed text-white/70">{p.confidentialityText}</p>
            </div>
          </div>
          <div className="lg:col-span-6 lg:pl-10 lg:border-l border-white/15">
            <h2 className="font-heading text-2xl font-semibold tracking-tight mb-4">{p.transferTitle}</h2>
            <p className="text-base leading-relaxed text-white/70">{p.transferText}</p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <RelatedLinks label={c.related} links={p.related} />
        </div>
      </section>

      <PageCta title={c.ctaTitle} text={c.ctaText} cta={t.cta} />
    </>
  );
}
